
import { Container } from "@material-ui/core";


export default function GestDirectorTecnico({ element: component, ...rest }) {
    // const classes = useStyles()

    return (<Container>{component}</Container>)
}